//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { marketMatchesScope } from '~/utils/marketMatching'
const betassist = require('~/data/betassist.json')
export default {
  components: {},
  props: ['market', 'event', 'showTitle', 'initiallyVisible', 'forceVisible'],
  computed: {
    betAssistMarket() {
        if(_.get(betassist, this.event.sport_id + '.' + this.market.market_type+ '|' + this.market.code_original))
          return _.get(betassist, this.event.sport_id + '.' + this.market.market_type+ '|' + this.market.code_original)
        return _.get(betassist, this.event.sport_id + '.' + this.market.market_type)
    },
    betAssistVisible() {
        return _.get(this.event, 'sportradar.betassist') && _.get(this.event, 'sportradar.match_id') && this.betAssistMarket
    },
    betAssistActive() {
        return this.$store.state.betAssistId == this.betAssistId
    },
    visible() {
        if(this.forceVisible === true) {
          return true
        }
        if(this.forceVisible === false) {
          return false
        }
        return this.outcomesVisible
    },
    grid() {
      if (_.get(this.market, 'outcomes.length') > 2) {
        return 'grid-cols-3'
      }
      return 'grid-cols-2'
    },
    betAssistId() {
      return this.market.market_type + '-' + this.betAssistMarket
    },
    seguro_combinada_config() {
      return this.$store.getters.seguroCombinadaConfig
    },
    seguro_combinada_scopes() {
      const sportConfigs = _.get(this.seguro_combinada_config, 'sport_configs', [])
      return _.flatMap(sportConfigs, (sc) => sc.config || [])
    },
    seguroCombinadaEligible() {
      if (!this.seguro_combinada_config || !this.market) return false

      const sportSlug = _.get(this.event, 'sport_slug')
      const providerCompetitionId = _.get(this.event, 'competition_id')
      const eventId = _.get(this.event, 'id')
      const marketTypeId = _.get(this.market, 'market_type')

      return this.seguro_combinada_scopes.some((scope) => {
        if (scope.sport_id && String(scope.sport_id).toLowerCase() !== String(sportSlug).toLowerCase()) return false
        if (scope.provider_competition_id && scope.provider_competition_id !== providerCompetitionId) return false
        if (scope.event_id && scope.event_id !== eventId) return false
        return marketMatchesScope(marketTypeId, scope)
      })
    },
    seguroTooltipUid() {
      return `${this.market.id}`
    }
  },
  data() {
    return {
      betAssistCode: null,
      outcomesVisible: false,
      loading: true,
      balance: null,
      showSeguroTooltip: false
    }
  },
  watch: {
    initiallyVisible: function (newOutcome, oldOutcome) {
      this.outcomesVisible = !!this.initiallyVisible;
    }
  },
  mounted() {
    this.outcomesVisible = !!this.initiallyVisible;
    this._onDocumentClick = (event) => {
      if (!this.showSeguroTooltip) return
      const wrapper = this.$refs.seguroWrapper
      if (wrapper && !wrapper.contains(event.target)) {
        this.showSeguroTooltip = false
      }
    }
    document.addEventListener('click', this._onDocumentClick)

    this._onSeguroTooltipOpened = (uid) => {
      if (uid !== this.seguroTooltipUid) {
        this.showSeguroTooltip = false
      }
    }
    this.$root.$on('seguro_tooltip_opened', this._onSeguroTooltipOpened)
  },
  beforeDestroy() {
    document.removeEventListener('click', this._onDocumentClick)
    this.$root.$off('seguro_tooltip_opened', this._onSeguroTooltipOpened)
  },
  methods: {
    toggleBetAssist() {
      this.$store.commit('setBetAssistId', (this.betAssistId == this.$store.state.betAssistId)?null:this.betAssistId)
    },
    toggle() {
      this.outcomesVisible = !this.outcomesVisible
    },
    show() {
      this.outcomesVisible = true
    },
    hide() {
      this.outcomesVisible = false
      if(this.betAssistId == this.$store.state.betAssistId) {
        this.$store.commit('setBetAssistId', null)
      }
    },
    toggleSeguroTooltip() {
      this.showSeguroTooltip = !this.showSeguroTooltip
      if (this.showSeguroTooltip) {
        this.$root.$emit('seguro_tooltip_opened', this.seguroTooltipUid)
      }
    }
  }
}
